module.exports = __webpack_public_path__ + "img/renaud_phenix.bc489b9d.jpg";